import { render, staticRenderFns } from "./topnav.vue?vue&type=template&id=1fb1e20c&scoped=true"
import script from "./topnav.vue?vue&type=script&lang=js"
export * from "./topnav.vue?vue&type=script&lang=js"
import style0 from "./topnav.vue?vue&type=style&index=0&id=1fb1e20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1e20c",
  null
  
)

export default component.exports